// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2h1W9","row":"ProcedureTreatmentSummary_row__23y6n"};